import { useState } from 'react';
import { useKeenSlider } from 'keen-slider/react.es';
import 'keen-slider/keen-slider.min.css';
import Image from '../image/Image';
import ButtonBase from '../button/ButtonBase';
import styles from './image-slider.module.less';

export const ImageSlider = ({ imageUrls }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [loaded, setLoaded] = useState(false);
    const [sliderRef, instanceRef] = useKeenSlider({
        initial: 0,
        slides: {
            perView: 1,
        },
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
        created() {
            setLoaded(true);
        },
    });

    return (
        <div className={styles.wrapper}>
            <div ref={sliderRef} className="keen-slider">
                {imageUrls.map((image) => (
                    <div key={image} className="keen-slider__slide">
                        <Image className={styles.images} src={image} role="presentation" />
                    </div>
                ))}
            </div>
            {loaded && instanceRef.current && instanceRef.current.track.details.slides.length > 1 && (
                <>
                    <ButtonBase
                        onClick={(e) => e.stopPropagation() || instanceRef.current?.prev()}
                        disabled={currentSlide === 0}
                        className={[styles.arrow, styles.arrowLeft].join(' ')}
                    >
                        <i className={['fa-regular fa-chevron-left', styles.arrowIcon].join(' ')} />
                    </ButtonBase>
                    <ButtonBase
                        onClick={(e) => e.stopPropagation() || instanceRef.current?.next()}
                        disabled={currentSlide === instanceRef.current.track.details.slides.length - 1}
                        className={[styles.arrow, styles.arrowRight].join(' ')}
                    >
                        <i className={['fa-regular fa-chevron-right', styles.arrowIcon].join(' ')} />
                    </ButtonBase>
                </>
            )}
            {loaded && instanceRef.current && instanceRef.current.track.details.slides.length > 1 && (
                <div className={styles.dots}>
                    {[...Array(instanceRef.current.track.details.slides.length || 0).keys()].map((idx) => {
                        return (
                            <i
                                key={idx}
                                className={[styles.dot, currentSlide === idx ? styles.dotActive : ''].join(' ')}
                            />
                        );
                    })}
                </div>
            )}
        </div>
    );
};
